import { useReactiveVar } from '@apollo/client'
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
import { modalVar } from '../../../../providers/apollo/cache'
import CreateAlbumForm from '../drawer/components/CreateAlbumForm'

export default function SubalbumCreate() {
  const { albumId, bucketId } = useParams<{ albumId: string; bucketId: string }>()
  const modal = useReactiveVar(modalVar)
  const open = modal === 'bucketSubalbumCreate'

  const handleClose = () => {
    modalVar(null)
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="body1" sx={{ flex: 1 }}>
          {albumId ? 'Create Subalbum' : 'Create Album'}
        </Typography>
      </DialogTitle>
      {!bucketId && (
        <DialogContent sx={{ padding: 3, paddingTop: 0 }}>
          <Typography variant="body2" color="textSecondary">
            There was an issue loading the details of your current bucket.
          </Typography>
        </DialogContent>
      )}
      {bucketId && (
        <DialogContent sx={{ padding: 3, paddingTop: 0 }}>
          <CreateAlbumForm bucketId={bucketId} albumId={albumId} handleClose={handleClose} />
        </DialogContent>
      )}
    </Dialog>
  )
}
